export const MAX_SESSION_DURATION = 1800000; // 30 minutes in ms
export const AD_IN_VIEW_PERCENTAGE = 50;

export const APP_ID =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuZXR3b3JrIjoiYWxsIiwicHJvZHVjdCI6InByaXNtIiwicGxhdGZvcm0iOiJ3ZWIiLCJhcHBJZCI6ImFsbC1wcmlzbS13ZWItNzI4aGtyIn0.4Fk4E28ffoFgCIcgNSG8xX5TP2n3PIU6c3jadumKULo';

export const URLS = {
  lightningOrigin: 'https://lightning.warnermediacdn.com',
  iFramePath: {
    DEV: '/cdptest/psmtk/getcdpid.html',
    TEST: '/cdptest/psmtk/getcdpid.html',
    PROD: '/cdp/psmtk/getcdpid.html',
    INTEGRATION: '/cdptest/psmtk/getcdpid.html',
    AUTOMATED_TEST: '/cdptest/psmtk/getcdpid.html',
  },
  thirdPartyCookie: '/cdp/psmtk/start.html',
  carouselScript: '/cdp/psm/assets/swiper/swiper-bundle.min.js',
  carouselStyles: '/cdp/psm/assets/swiper/swiper-bundle.min.css',
  locate: 'https://geo.ngtv.io/locate',
  locateV2: 'https://atlas.ngtv.io/v2/locate',
  featureFlag: {
    DEV: 'https://wmff.warnermediacdn.com/psm_2_dev_full.json',
    TEST: 'https://wmff.warnermediacdn.com/psm_2_qa_full.json',
    PROD: 'https://wmff.warnermediacdn.com/psm_2_prod_full.json',
    INTEGRATION: 'https://wmff.warnermediacdn.com/psm_2_brand_integration_full.json',
    AUTOMATED_TEST: 'https://wmff.warnermediacdn.com/psm_2_automated_test_full.json',
  },
  identity: {
    DEV: 'https://dev.receive.wmcdp.io/v1/reg',
    TEST: 'https://test.receive.wmcdp.io/v1/reg',
    PROD: 'https://receive.wmcdp.io/v1/reg',
    INTEGRATION: 'https://test.receive.wmcdp.io/v1/reg',
    AUTOMATED_TEST: 'https://test.receive.wmcdp.io/v1/reg',
  },
  logs: {
    DEV: 'https://dev.receive.wmcdp.io/v1/reg',
    TEST: 'https://test.receive.wmcdp.io/v1/reg',
    PROD: 'https://receive.wmcdp.io/v1/reg',
    INTEGRATION: 'https://test.receive.wmcdp.io/v1/reg',
    AUTOMATED_TEST: 'https://test.receive.wmcdp.io/v1/reg',
  },
  authSvc: {
    DEV: 'https://dev.token.wmcdp.io/v1/token',
    TEST: 'https://test.token.wmcdp.io/v1/token',
    PROD: 'https://token.wmcdp.io/v1/token',
    INTEGRATION: 'https://test.token.wmcdp.io/v1/token',
    AUTOMATED_TEST: 'https://test.token.wmcdp.io/v1/token',
  },
};

export const CCPA_LOCATIONS = ['', 'US', 'GU', 'AS', 'PR', 'VI', 'MH', 'UM', 'MP'];
export const EMEA_LOCATIONS = [
  'AF',
  'AX',
  'AL',
  'DZ',
  'AD',
  'AO',
  'AM',
  'AT',
  'AZ',
  'BH',
  'BE',
  'BJ',
  'BA',
  'BW',
  'BV',
  'BG',
  'BF',
  'BI',
  'CM',
  'CV',
  'CF',
  'TD',
  'KM',
  'CD',
  'CG',
  'CI',
  'HR',
  'CY',
  'CZ',
  'DK',
  'DJ',
  'EG',
  'GQ',
  'ER',
  'EE',
  'ET',
  'FK',
  'FO',
  'FI',
  'FR',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GI',
  'GR',
  'GL',
  'GG',
  'GN',
  'GW',
  'VA',
  'HU',
  'IS',
  'IQ',
  'IE',
  'IM',
  'IL',
  'IT',
  'JE',
  'JO',
  'KZ',
  'KE',
  'KW',
  'LV',
  'LB',
  'LS',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MK',
  'MG',
  'MW',
  'ML',
  'MT',
  'MR',
  'MU',
  'YT',
  'MD',
  'MC',
  'ME',
  'MA',
  'MZ',
  'NA',
  'NL',
  'NE',
  'NG',
  'NO',
  'OM',
  'PS',
  'PL',
  'PT',
  'QA',
  'RE',
  'RO',
  'RW',
  'SH',
  'SM',
  'ST',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SK',
  'SI',
  'SO',
  'ZA',
  'GS',
  'SS',
  'ES',
  'SD',
  'SJ',
  'SZ',
  'SE',
  'CH',
  'SY',
  'TZ',
  'TG',
  'TN',
  'TR',
  'UG',
  'UA',
  'AE',
  'GB',
  'EH',
  'YE',
  'ZM',
  'ZW',
];
export const LATAM_LOCATIONS = [
  'AI',
  'AG',
  'AR',
  'AW',
  'BS',
  'BB',
  'BZ',
  'BO',
  'BR',
  'KY',
  'CL',
  'CO',
  'CR',
  'CW',
  'DM',
  'DO',
  'EC',
  'SV',
  'GD',
  'GT',
  'GY',
  'HT',
  'HN',
  'JM',
  'MX',
  'MS',
  'NI',
  'PA',
  'PY',
  'PE',
  'KN',
  'LC',
  'VC',
  'SR',
  'TT',
  'TC',
  'UY',
  'VE',
  'VI',
  'VG',
];

export const LOCALSTORAGE_WMUKID_KEY = 'WMUKID';
export const LS_SESSION_ID_KEY = 'psmSessionId';
export const LS_SESSION_START_KEY = 'psmSessionStart';
export const LAST_SESSION_TIME_LOCAL_STORAGE = 'last_session_time_local_storage';
export const CONFIG_REFRESH_INTERVAL = 60000;
export const PRIVACY_COMPANY_NAME = 'WarnerMedia';

export const LOCAL_STORAGE_KEY_CCPA_ALLOW_DATA = 'USP_String';
export const CCPA_ALLOW_DATA_SALE = '1YNN';
export const DEFAULT_CCPA_SETTING = CCPA_ALLOW_DATA_SALE;
export const CCPA_DO_NOT_ALLOW_DATA_SALE = '1YYN';

export const CCPA_NON_USP_LOCATION = '1---';
export const COM_SCORE_ALLOW = 1;
export const COM_SCORE_DO_NOT_ALLOW = 0;

// Local FF config for FFClient quick init
export const featureFlagLocalConfig = {
  featureFlagLibraryVersion: '0.1',
  flags: [
    {
      defaultValue: true,
      id: 'doppler-identity-onstart',
      cohorts: [],
      name: 'FALLBACK_doppler-identity-onstart',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-identity-oncomplete',
      cohorts: [],
      name: 'FALLBACK_doppler-identity-oncomplete',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-session',
      cohorts: [],
      name: 'FALLBACK_doppler-session',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-privacy',
      cohorts: [],
      name: 'FALLBACK_doppler-privacy',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-telemetry',
      cohorts: [],
      name: 'FALLBACK_doppler-telemetry',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-consent-update',
      cohorts: [],
      name: 'FALLBACK_doppler-consent-update',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'doppler-pubsub-event',
      cohorts: [],
      name: 'FALLBACK_doppler-pubsub-event',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-send-logs',
      cohorts: [],
      name: 'FALLBACK_doppler-send-logs',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'doppler-send-token-event',
      cohorts: [],
      name: 'FALLBACK_doppler-send-token-event',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'outside-us-location-check',
      cohorts: [],
      name: 'FALLBACK_outside_us_location_check',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'sendAuthToken',
      cohorts: [],
      name: 'FALLBACK_sendAuthToken',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'auth-service',
      cohorts: [],
      name: 'FALLBACK_auth-service',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'isInAuthTokenExperiment',
      cohorts: [],
      name: 'FALLBACK_isInAuthTokenExperiment',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'sendWMSegs',
      cohorts: [],
      name: 'FALLBACK_sendWMSegs',
      type: 'boolean',
    },
  ],
};

// Default flag values in case there's an issue with the FF client
export const featureFlagDefaults = {
  'auth-service': false,
  'doppler-identity-onstart': true,
  'doppler-identity-oncomplete': true,
  'doppler-session': true,
  'doppler-privacy': true,
  'doppler-telemetry': true,
  'doppler-consent-update': true,
  'doppler-pubsub-event': false,
  'outside-us-location-check': false,
  'doppler-send-logs': true,
  'doppler-send-token-event': false,
  sendAuthToken: false,
  isInAuthTokenExperiment: false,
  sendWMSegs: false,
  // for unit tests
  'test-enabled': true,
  'test-disabled': false,
};

export const queueOptions = {
  minRetryDelay: 30000,
  maxRetryDelay: 120000,
  maxItems: 5,
  maxAttempts: 10,
  backoffFactor: 2,
  backoffJitter: 0,
};

export enum COPPAPrivacyModesEnum {
  ALL_ID = 'ALL_ID',
  ZERO_ID = 'ZERO_ID',
}
